import type { Channel, MissionDashboard } from '@sentinel/shared';
import { teamsWithoutNode } from '@/core/mission/team-readiness';
import type { NavBadgeKey } from './navigation';

/** How a counter is drawn: critical, attention or neutral (DS «badge numero + parola»). */
export type NavBadgeTone = 'crit' | 'att' | 'neu';

export interface NavBadge {
  count: number;
  tone: NavBadgeTone;
}

/** The counters of the PCA sidebar from data the shell already has: open alarms, teams without
 *  a node, unread messages, devices offline. A zero shows nothing. */
export function navBadges(
  dashboard: MissionDashboard | undefined,
  channels: readonly Channel[] | undefined,
): Partial<Record<NavBadgeKey, NavBadge>> {
  const badges: Partial<Record<NavBadgeKey, NavBadge>> = {};
  const add = (key: NavBadgeKey, count: number, tone: NavBadgeTone) => {
    if (count > 0) badges[key] = { count, tone };
  };
  if (dashboard !== undefined) {
    const open = dashboard.alarms.filter((a) => a.status !== 'closed').length;
    add('alarms', open, 'crit');
    add('teamsWithoutNode', teamsWithoutNode(dashboard), 'att');
    add('devicesOffline', dashboard.kpis.devicesTotal - dashboard.kpis.devicesOnline, 'att');
  }
  if (channels !== undefined) {
    add(
      'unread',
      channels.reduce((sum, c) => sum + c.unread, 0),
      'neu',
    );
  }
  return badges;
}
